const w = window;
const RIC_NAME = "requestIdleCallback";
export { w as window };
export const { requestAnimationFrame, //
cancelAnimationFrame, setTimeout, clearTimeout, setInterval, clearInterval, getComputedStyle, document, document: { body, head, scrollingElement, documentElement }, } = w;
/**
 * For convenience the id param ist not restricted, browser will call the toString()
 */
export const getElementById = (id, doc) => (doc ?? document).getElementById(id);
export const requestIdleCallback = RIC_NAME in w ? w[RIC_NAME] : requestAnimationFrame;
export const cancelIdleCallback = RIC_NAME in w ? w["cancelIdleCallback"] : cancelAnimationFrame;
export { getCookies } from './cookie.js';
export const defineElement = (name, constructor) => {
    w.customElements.define(name, constructor);
};
